import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorBannerService } from '../../../core/services/error-banner.service';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrl: './error-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorBannerComponent implements OnDestroy {
  currentMessage: string | null = null;
  private sub: Subscription;

  constructor(
    private errorBannerService: ErrorBannerService,
    private cdr: ChangeDetectorRef,
  ) {
    this.sub = this.errorBannerService.message$.subscribe(message => {
      this.currentMessage = message;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  dismiss(): void {
    this.errorBannerService.clear();
  }
}
